import { withProps } from 'recompose'
import { Form as CoreForm } from 'formik'

export const Form = withProps({
  noValidate: true
})(CoreForm)